import styles from './EmptyBank.module.scss';
import emptyBank from '../../../../../../assets/empty-bank.svg';

function EmptyBank({
    text = '',
    style,
    subText,
    buttonComponent = null,
}: {
    text?: string;
    style?: React.CSSProperties;
    subText?: string;
    buttonComponent?: React.ReactNode | null;
}) {
    return (
        <div className={styles.EmptyBank} style={style}>
            <img src={emptyBank} alt="" height="106px" />
            {text}

            {subText && <div className={styles.SubText}>{subText}</div>}

            {buttonComponent}
        </div>
    );
}

export default EmptyBank;
